var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 435 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Sans-serif",
    fontSize: 55,
    fontWeight: "bold",
    id: "svg_1",
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1, 0, 0, 1, 0, 0) matrix(4.45348, 0, 0, 3.901, -258.546, -391.16)",
    x: 74.29,
    xmlSpace: "preserve",
    y: 149.94
  }, "4"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Sans-serif",
    fontSize: 15,
    fontWeight: "bold",
    id: "svg_2",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1, 0, 0, 1, 0, 0) matrix(1.06969, 0, 0, 1.25744, -13.244, -67.1994)",
    x: 217.42,
    xmlSpace: "preserve",
    y: 272.31
  }, "PAGE NOT FOUND"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Sans-serif",
    fontSize: 42,
    fontWeight: "bold",
    id: "svg_4",
    letterSpacing: 0,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    x: 218.27,
    xmlSpace: "preserve",
    y: 246.13
  }, "ERROR"), /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m266.19,109.11c-3.61,-0.86 -15.55,-21.8 -15.5,-27.24c0.05,-3.05 16.56,-27.85 17.94,-27.69c1.38,0.05 15.6,21.85 15.23,26.98c-0.64,7.62 -14.65,28.25 -17.67,27.95z",
    fill: "#ffffff",
    id: "path3564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.72,49.15c2.02,2.08 -14.65,25.81 -17.73,27.74c-4.35,2.79 -33.38,2.29 -34.02,-0.2c-0.11,-2.08 12.95,-23.58 17.89,-26.02c7.38,-3.61 32.53,-2.64 33.86,-1.52z",
    fill: "#ffffff",
    id: "path3566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.56,83.5c2.97,-1.42 31.05,-1.07 34.02,0.51c2.76,1.63 15.44,26.22 14.86,27.08c-1.54,3.61 -27.97,2.69 -32.85,0.15c-5.52,-2.85 -17.83,-25.97 -16.03,-27.74z",
    fill: "#ffffff",
    id: "path3568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.68,143.76c-3.61,-0.86 -14.44,-24.09 -14.38,-29.52c0.05,-3.05 15.55,-28.66 16.98,-28.51c1.38,0.05 12.05,22.16 11.68,27.29c-0.64,7.62 -11.25,31.05 -14.28,30.74z",
    fill: "#ffffff",
    id: "path3570"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.55,83.09c2.07,2.08 -15.13,25.56 -18.26,27.44c-4.35,2.85 -32.85,2.64 -33.44,0.1c-0.11,-2.08 12.95,-23.58 17.89,-26.02c7.32,-3.56 32.53,-2.64 33.81,-1.52l0,0z",
    fill: "#ffffff",
    id: "path3572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.8,118.15c2.97,-1.42 31.42,0 34.34,1.63c2.81,1.63 15.39,23.58 14.54,25.97c-1.59,3.56 -28.29,1.93 -33.12,-0.61c-5.57,-2.85 -17.62,-25.2 -15.76,-26.98z",
    fill: "#ffffff",
    id: "path3574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.38,177.61c-3.56,-0.86 -15.55,-21.8 -15.44,-27.24c0.05,-3.05 16.51,-27.85 17.94,-27.69c1.38,0.05 15.6,21.85 15.18,26.98c-0.58,7.62 -14.65,28.25 -17.67,27.95z",
    fill: "#ffffff",
    id: "path3576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.61,118c2.02,2.03 -14.65,25.81 -17.73,27.74c-4.35,2.79 -36.83,3.25 -37.42,0.76c-0.11,-2.08 16.51,-22.71 21.39,-25.15c7.38,-3.61 32.43,-4.52 33.76,-3.35z",
    fill: "#ffffff",
    id: "path3578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.49,153.52c2.92,-1.42 31.05,-1.07 33.97,0.51c2.81,1.63 15.5,26.22 14.91,27.08c-1.59,3.61 -28.29,1.93 -33.12,-0.61c-5.57,-2.85 -17.62,-25.2 -15.76,-26.98z",
    fill: "#ffffff",
    id: "path3580"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: 55,
    fontWeight: "bold",
    id: "svg_7",
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1, 0, 0, 1, 0, 0) matrix(4.45348, 0, 0, 3.901, -258.546, -391.16)",
    x: 139.92,
    xmlSpace: "preserve",
    y: 149.56
  }, "4"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.24c0dcc81f0faf7c0daae2882894d668.svg";
export { ForwardRef as ReactComponent };